<template>
  <div v-if="documents">
    <div
      v-for="(document, idx) in documents"
      :key="`type-${idx}-${document.documentFilename}`"
    >
      <div
        v-if="
          specialistLicensefileUploadVisibility(
            document.specialistLicenseDocumentTypeId
          )
        "
        class="bg-secondary-3 mt-4 rounded p-4"
        :class="{ 'bg-white': !isEditing }"
      >
        <div class="row pt-3" style="border-top:1px solid #eee">
          <div class="col-md-4">
            <label class="data-title mb-0">Tipo de documento:</label>
            <p>{{ document.specialistLicenseDocumentTypeName | empty }}</p>
          </div>
          <div class="col-md-4">
            <label class="data-title mb-0">Archivo:</label>
            <p v-if="document.documentId || document.guid">
              {{ document.documentFilename | empty }}
            </p>
            <validation-provider
              v-else
              v-slot="{ errors }"
              :name="
                `specialistLicensefileUploadRef${document.specialistLicenseDocumentTypeId}`
              "
            >
              <custom-file-input
                :ref="
                  `specialistLicensefileUploadRef${document.specialistLicenseDocumentTypeId}`
                "
                :accept="allowedFiles"
                accept-terms-modal-title="Certificación"
                accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
                accept-terms-title="Acepto los términos y responsabilidades"
                accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
                allow-accept-terms
                :attachment-id="document.documentId"
                :custom-error-msg="
                  specialistLicenseCustomError(
                    document.specialistLicenseDocumentTypeId
                  )
                "
                display-style="normal"
                :error="errors[0]"
                label-position="left"
                :on-download="onDownloadFile"
                :value="document.attachment"
                @input="(file) => onChangeFile(file, document)"
              />
            </validation-provider>
          </div>
          <div
            v-if="document.documentId || document.guid"
            class="col-md-2 pl-0"
          >
            <div class="mt-3 ">
              <action-button
                class="mr-2 border-green document-button-icon"
                i="fas fa-file-download text-green mr-n1 pr-1"
                @click="downloadDocument(document)"
              />
              <action-button
                class="border-danger document-button-icon"
                i="fas fa-times-circle text-red mr-n1 pr-1"
                @click="deleteDocument(document)"
              />
            </div>
          </div>
          <div
            v-if="
              document.specialistLicenseDocumentTypeId ===
                specialistLicenseDocumentTypes.CertForCyberTherapy &&
                (document.documentId || document.guid)
            "
            class="col-md pl-0 pr-1"
          >
            <label class="data-title mb-0">Fecha de Expiración:</label>
            <div v-if="document.guid">
              <validation-provider
                v-slot="{ errors }"
                name="licenseDueDate"
                rules="required"
              >
                <custom-date-picker
                  v-model="document.licenseDocumentExpiryDate"
                  :class-container="'w-100'"
                  :custom-error-msg="'La fecha de expiración es requerida.'"
                  :error="errors[0]"
                  format="dd/MMM./yyyy"
                  :min-date="currentDate"
                />
              </validation-provider>
            </div>

            <div v-if="document.documentId">
              <label for="">
                {{ document.licenseDocumentExpiryDate | date }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from '@/components/common/form/CustomDatePicker';
import CustomFileInput from '@/components/common/CustomFileInput';
import alertMixin from '@/mixins/alert.mixin.js';

const licenseDocumentTypesEnum = Object.freeze({
  SpecialistLicense: 1,
  Collegiation: 2,
  Law300: 3,
  CertForCyberTherapy: 4,
});

export default {
  components: {
    CustomDatePicker,
    CustomFileInput,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      specialistLicenseDocumentTypes: licenseDocumentTypesEnum,
      documentSelectedId: null,
      documents: [],
    };
  },
  computed: {
    currentDate() {
      return new Date();
    },
    allowedFiles() {
      return '.pdf';
    },
    isEditing() {
      return Boolean(this.value.specialistLicenseId);
    },
    isOccupationalTherapistOrTherapyAssistant() {
      if (!this.value.specialtyTypeId) return false;
      const specialistTypes = Object.freeze({
        OccupationalTherapyAssistant: 2,
        OccupationalTherapist: 15,
        PhysicalTherapyAssistant: 1,
        SpeechAndLanguageTherapist: 14,
        GradeCertification: 36,
      });
      return [
        specialistTypes.OccupationalTherapyAssistant,
        specialistTypes.OccupationalTherapist,
      ].includes(this.value.specialtyTypeId);
    },
    specialistLicensefileUploadVisibility() {
      return (specialistLicenseDocumentTypeId) => {
        if (
          specialistLicenseDocumentTypeId !==
          this.specialistLicenseDocumentTypes.Collegiation
        ) {
          return true;
        }
        return this.isOccupationalTherapistOrTherapyAssistant;
      };
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.documents = newValue?.documents ?? [];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    specialistLicenseCustomError(specialistLicenseDocumentTypeId) {
      let message = '';
      switch (specialistLicenseDocumentTypeId) {
        case this.specialistLicenseDocumentTypes.SpecialistLicense:
          message = 'licencia';
          break;
        case this.specialistLicenseDocumentTypes.Collegiation:
          message = 'colegiación';
          break;
        case this.specialistLicenseDocumentTypes.Law300:
          message = 'Certificación del Puerto Rico Background Check Program';
          break;
        default:
          break;
      }
      return `El documento de la ${message} es requerido.`;
    },
    onChangeFile(file, doc) {
      if (file) {
        this.documentSelectedId = doc.specialistLicenseDocumentTypeId;
        doc.attachment = file;
        doc.documentFilename = file.name;
        doc.guid = this.builtUniqueId();
      }
    },
    downloadDocument(doc) {
      this.$emit('download-document', doc);
    },
    async deleteDocument(doc) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea <b>Eliminar</b> el archivo <b>${doc.documentFilename}</b>?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      this.$emit('delete-document', doc);
    },
    async onDownloadFile() {
      return new Promise();
    },
    builtUniqueId() {
      return (
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .substr(2)
      );
    },
  },
};
</script>
